/** Format digits as card number groups: 4242 4242 4242 4242 */
export function formatCardNumber(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 19);
  return digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
}

/** Format expiry as MM/YY */
export function formatCardExpiry(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export function formatCardCvv(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 4);
}

export function cardDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

export function maskCardNumber(value) {
  const digits = cardDigits(value);
  if (digits.length < 4) return digits;
  const last4 = digits.slice(-4);
  return `**** **** **** ${last4}`;
}
